import React from 'react';
import classNames from 'classnames';

import css from './DialogPrompt.less';

const DialogPrompt = ({
  message,
  children,
  confirmText = '好的',
  onConfirm,
  className,
  style,
  overlayClassName,
  overlayStyle,
  withOverlay = true,
  buttonProps = {},
}) => {
  const content = children || (message ? <p className={css.message}>{message}</p> : null);
  const { className: buttonClassName, onClick: buttonOnClick, ...restButtonProps } = buttonProps;

  const handleConfirm = event => {
    if (typeof buttonOnClick === 'function') {
      buttonOnClick(event);
    }

    if (event?.defaultPrevented) {
      return;
    }

    if (typeof onConfirm === 'function') {
      onConfirm(event);
    }
  };

  const promptBody = (
    <section className={classNames(css.prompt, className)} style={style}>
      {content}
      <button
        type="button"
        className={classNames(css.confirmButton, buttonClassName)}
        onClick={handleConfirm}
        {...restButtonProps}
      >
        {confirmText}
      </button>
    </section>
  );

  if (!withOverlay) {
    return promptBody;
  }

  return (
    <div className={classNames(css.overlay, overlayClassName)} style={overlayStyle}>
      {promptBody}
    </div>
  );
};

export default DialogPrompt;
